import { render, staticRenderFns } from "./ChatSite.vue?vue&type=template&id=bd3710d6&scoped=true&"
import script from "./ChatSite.vue?vue&type=script&lang=js&"
export * from "./ChatSite.vue?vue&type=script&lang=js&"
import style0 from "./ChatSite.vue?vue&type=style&index=0&id=bd3710d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3710d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VContainer,VIcon,VTab,VTabs,VTooltip})
